// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__WZ955","active":"Navbar_active__xIlh8"};